import type { SVGProps } from 'react'

type Panorama720IconProps = Omit<SVGProps<SVGSVGElement>, 'height' | 'width'> & {
  size?: number | string
}

/** "720" over a two-headed rotation arc, used by every location 720 action. */
export function Panorama720Icon({ size = 16, ...props }: Panorama720IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2.5 3h5l-3 9" />
      <path d="M9.5 5.5a2.5 2.5 0 0 1 5 0c0 1.6-1.2 2.6-5 6.5h5" />
      <rect x="16.5" y="3" width="5" height="9" rx="2.5" />
      <path d="M3.5 16a9 6 0 0 0 17 0" />
      <path d="M5.9 16.7 3.5 16l-.6 2.4" />
      <path d="m18.1 16.7 2.4-.7.6 2.4" />
    </svg>
  )
}
